/* GET SINGLE SOFT SKILL COURSE */
export const PUBLISH_SOFTSKILLS_COURSE = "PUBLISH_SOFTSKILLS_COURSE"
export const PUBLISH_SOFTSKILLS_COURSE_SUCCESS =
  "PUBLISH_SOFTSKILLS_COURSE_SUCCESS"
export const PUBLISH_SOFTSKILLS_COURSE_CLEAN = "PUBLISH_SOFTSKILLS_COURSE_CLEAN"
export const PUBLISH_SOFTSKILLS_COURSE_ERROR = "PUBLISH_SOFTSKILLS_COURSE_ERROR"
